import { getInitialData } from '../utils/api'
import { receiveQuestions } from '../actions/questions'
import { receiveRFPData, receiveOtherRFPs } from '../actions/rfp'
import { showLoading, hideLoading } from 'react-redux-loading'

export function handleInitialData (hashId) {
	return (dispatch) => {
		dispatch(showLoading())

		return getInitialData(hashId)
			.then(({ rfpData, questions, otherRFPs }) => {
				dispatch(receiveRFPData(rfpData))
				dispatch(receiveQuestions(questions))
				dispatch(receiveOtherRFPs(otherRFPs))
				dispatch(hideLoading())
			})
	}
}


// WEBPACK FOOTER //
// ./src/actions/shared.js